/*
 * cart-address.js — Sepette Ülke → İl → İlçe kademeli seçici (Black Fashion perakende)
 * -----------------------------------------------------------------------------------
 * Amaç: Müşteri sepette Ülke/İl/İlçe seçsin; "Ödemeye geç"e basınca bu bilgiler
 *       checkout adres alanlarına OTOMATİK dolsun.
 *
 * Doğrulanmış checkout eşlemesi (blackfashion.com.tr, 2026-07-08 canlı test):
 *   İl   → checkout[shipping_address][city]      (checkout'ta "Şehir" alanı)
 *   İlçe → checkout[shipping_address][address2]  (checkout'ta "İlçe" alanı)
 *   Ülke → checkout[shipping_address][country]   (ISO 2-harf kod, ör. TR)
 *
 * Yöntem: Sepet formuna gizli input olarak eklenir; native checkout butonu bunları
 *         checkout'a taşır. Sepet içeriğine/akışına DOKUNULMAZ (yeniden kurulmaz).
 */
(function () {
  'use strict';

  var LS_KEY = 'bf_cart_address_v1';

  // Ülke listesi: Türkiye ilk (varsayılan) + yurtdışı kargo tablosundaki 32 ülke.
  // value = ISO 3166-1 alpha-2 kodu (checkout country parametresi kodu kabul eder).
  var COUNTRIES = [
    { code: 'TR', name: 'Türkiye' },
    { code: 'BG', name: 'Bulgaristan' },
    { code: 'RO', name: 'Romanya' },
    { code: 'SK', name: 'Slovakya' }
  ];

  // 81 il → ilçeleri. Anahtar = checkout "Şehir" alanına yazılacak il adı.
  var TR = {
    'Adana': ['Aladağ','Ceyhan','Çukurova','Feke','İmamoğlu','Karaisalı','Karataş','Kozan','Pozantı','Saimbeyli','Sarıçam','Seyhan','Tufanbeyli','Yumurtalık','Yüreğir'],
    'Adıyaman': ['Besni','Çelikhan','Gerger','Gölbaşı','Kâhta','Merkez','Samsat','Sincik','Tut'],
    'Afyonkarahisar': ['Başmakçı','Bayat','Bolvadin','Çay','Çobanlar','Dazkırı','Dinar','Emirdağ','Evciler','Hocalar','İhsaniye','İscehisar','Kızılören','Merkez','Sandıklı','Sinanpaşa','Sultandağı','Şuhut'],
    'Ağrı': ['Diyadin','Doğubayazıt','Eleşkirt','Hamur','Merkez','Patnos','Taşlıçay','Tutak'],
    'Aksaray': ['Ağaçören','Eskil','Gülağaç','Güzelyurt','Merkez','Ortaköy','Sarıyahşi','Sultanhanı'],
    'Amasya': ['Göynücek','Gümüşhacıköy','Hamamözü','Merkez','Merzifon','Suluova','Taşova'],
    'Ankara': ['Akyurt','Altındağ','Ayaş','Bala','Beypazarı','Çamlıdere','Çankaya','Çubuk','Elmadağ','Etimesgut','Evren','Gölbaşı','Güdül','Haymana','Kahramankazan','Kalecik','Keçiören','Kızılcahamam','Mamak','Nallıhan','Polatlı','Pursaklar','Sincan','Şereflikoçhisar','Yenimahalle'],
    'Antalya': ['Akseki','Aksu','Alanya','Demre','Döşemealtı','Elmalı','Finike','Gazipaşa','Gündoğmuş','İbradı','Kaş','Kemer','Kepez','Konyaaltı','Korkuteli','Kumluca','Manavgat','Muratpaşa','Serik'],
    'Ardahan': ['Çıldır','Damal','Göle','Hanak','Merkez','Posof'],
    'Artvin': ['Ardanuç','Arhavi','Borçka','Hopa','Kemalpaşa','Merkez','Murgul','Şavşat','Yusufeli'],
    'Aydın': ['Bozdoğan','Buharkent','Çine','Didim','Efeler','Germencik','İncirliova','Karacasu','Karpuzlu','Koçarlı','Köşk','Kuşadası','Kuyucak','Nazilli','Söke','Sultanhisar','Yenipazar'],
    'Balıkesir': ['Altıeylül','Ayvalık','Balya','Bandırma','Bigadiç','Burhaniye','Dursunbey','Edremit','Erdek','Gömeç','Gönen','Havran','İvrindi','Karesi','Kepsut','Manyas','Marmara','Savaştepe','Sındırgı','Susurluk'],
    'Bartın': ['Amasra','Kurucaşile','Merkez','Ulus'],
    'Batman': ['Beşiri','Gercüş','Hasankeyf','Kozluk','Merkez','Sason'],
    'Bayburt': ['Aydıntepe','Demirözü','Merkez'],
    'Bilecik': ['Bozüyük','Gölpazarı','İnhisar','Merkez','Osmaneli','Pazaryeri','Söğüt','Yenipazar'],
    'Bingöl': ['Adaklı','Genç','Karlıova','Kiğı','Merkez','Solhan','Yayladere','Yedisu'],
    'Bitlis': ['Adilcevaz','Ahlat','Güroymak','Hizan','Merkez','Mutki','Tatvan'],
    'Bolu': ['Dörtdivan','Gerede','Göynük','Kıbrıscık','Mengen','Merkez','Mudurnu','Seben','Yeniçağa'],
    'Burdur': ['Ağlasun','Altınyayla','Bucak','Çavdır','Çeltikçi','Gölhisar','Karamanlı','Kemer','Merkez','Tefenni','Yeşilova'],
    'Bursa': ['Büyükorhan','Gemlik','Gürsu','Harmancık','İnegöl','İznik','Karacabey','Keles','Kestel','Mudanya','Mustafakemalpaşa','Nilüfer','Orhaneli','Orhangazi','Osmangazi','Yenişehir','Yıldırım'],
    'Çanakkale': ['Ayvacık','Bayramiç','Biga','Bozcaada','Çan','Eceabat','Ezine','Gelibolu','Gökçeada','Lapseki','Merkez','Yenice'],
    'Çankırı': ['Atkaracalar','Bayramören','Çerkeş','Eldivan','Ilgaz','Kızılırmak','Korgun','Kurşunlu','Merkez','Orta','Şabanözü','Yapraklı'],
    'Çorum': ['Alaca','Bayat','Boğazkale','Dodurga','İskilip','Kargı','Laçin','Mecitözü','Merkez','Oğuzlar','Ortaköy','Osmancık','Sungurlu','Uğurludağ'],
    'Denizli': ['Acıpayam','Babadağ','Baklan','Bekilli','Beyağaç','Bozkurt','Buldan','Çal','Çameli','Çardak','Çivril','Güney','Honaz','Kale','Merkezefendi','Pamukkale','Sarayköy','Serinhisar','Tavas'],
    'Diyarbakır': ['Bağlar','Bismil','Çermik','Çınar','Çüngüş','Dicle','Eğil','Ergani','Hani','Hazro','Kayapınar','Kocaköy','Kulp','Lice','Silvan','Sur','Yenişehir'],
    'Düzce': ['Akçakoca','Cumayeri','Çilimli','Gölyaka','Gümüşova','Kaynaşlı','Merkez','Yığılca'],
    'Edirne': ['Enez','Havsa','İpsala','Keşan','Lalapaşa','Meriç','Merkez','Süloğlu','Uzunköprü'],
    'Elazığ': ['Ağın','Alacakaya','Arıcak','Baskil','Karakoçan','Keban','Kovancılar','Maden','Merkez','Palu','Sivrice'],
    'Erzincan': ['Çayırlı','İliç','Kemah','Kemaliye','Merkez','Otlukbeli','Refahiye','Tercan','Üzümlü'],
    'Erzurum': ['Aşkale','Aziziye','Çat','Hınıs','Horasan','İspir','Karaçoban','Karayazı','Köprüköy','Narman','Oltu','Olur','Palandöken','Pasinler','Pazaryolu','Şenkaya','Tekman','Tortum','Uzundere','Yakutiye'],
    'Eskişehir': ['Alpu','Beylikova','Çifteler','Günyüzü','Han','İnönü','Mahmudiye','Mihalgazi','Mihalıççık','Odunpazarı','Sarıcakaya','Seyitgazi','Sivrihisar','Tepebaşı'],
    'Gaziantep': ['Araban','İslahiye','Karkamış','Nizip','Nurdağı','Oğuzeli','Şahinbey','Şehitkamil','Yavuzeli'],
    'Giresun': ['Alucra','Bulancak','Çamoluk','Çanakçı','Dereli','Doğankent','Espiye','Eynesil','Görele','Güce','Keşap','Merkez','Piraziz','Şebinkarahisar','Tirebolu','Yağlıdere'],
    'Gümüşhane': ['Kelkit','Köse','Kürtün','Merkez','Şiran','Torul'],
    'Hakkari': ['Çukurca','Derecik','Merkez','Şemdinli','Yüksekova'],
    'Hatay': ['Altınözü','Antakya','Arsuz','Belen','Defne','Dörtyol','Erzin','Hassa','İskenderun','Kırıkhan','Kumlu','Payas','Reyhanlı','Samandağ','Yayladağı'],
    'Iğdır': ['Aralık','Karakoyunlu','Merkez','Tuzluca'],
    'Isparta': ['Aksu','Atabey','Eğirdir','Gelendost','Gönen','Keçiborlu','Merkez','Senirkent','Sütçüler','Şarkikaraağaç','Uluborlu','Yalvaç','Yenişarbademli'],
    'İstanbul': ['Adalar','Arnavutköy','Ataşehir','Avcılar','Bağcılar','Bahçelievler','Bakırköy','Başakşehir','Bayrampaşa','Beşiktaş','Beykoz','Beylikdüzü','Beyoğlu','Büyükçekmece','Çatalca','Çekmeköy','Esenler','Esenyurt','Eyüpsultan','Fatih','Gaziosmanpaşa','Güngören','Kadıköy','Kağıthane','Kartal','Küçükçekmece','Maltepe','Pendik','Sancaktepe','Sarıyer','Silivri','Sultanbeyli','Sultangazi','Şile','Şişli','Tuzla','Ümraniye','Üsküdar','Zeytinburnu'],
    'İzmir': ['Aliağa','Balçova','Bayındır','Bayraklı','Bergama','Beydağ','Bornova','Buca','Çeşme','Çiğli','Dikili','Foça','Gaziemir','Güzelbahçe','Karabağlar','Karaburun','Karşıyaka','Kemalpaşa','Kınık','Kiraz','Konak','Menderes','Menemen','Narlıdere','Ödemiş','Seferihisar','Selçuk','Tire','Torbalı','Urla'],
    'Kahramanmaraş': ['Afşin','Andırın','Çağlayancerit','Dulkadiroğlu','Ekinözü','Elbistan','Göksun','Nurhak','Onikişubat','Pazarcık','Türkoğlu'],
    'Karabük': ['Eflani','Eskipazar','Merkez','Ovacık','Safranbolu','Yenice'],
    'Karaman': ['Ayrancı','Başyayla','Ermenek','Kazımkarabekir','Merkez','Sarıveliler'],
    'Kars': ['Akyaka','Arpaçay','Digor','Kağızman','Merkez','Sarıkamış','Selim','Susuz'],
    'Kastamonu': ['Abana','Ağlı','Araç','Azdavay','Bozkurt','Cide','Çatalzeytin','Daday','Devrekani','Doğanyurt','Hanönü','İhsangazi','İnebolu','Küre','Merkez','Pınarbaşı','Şenpazar','Seydiler','Taşköprü','Tosya'],
    'Kayseri': ['Akkışla','Bünyan','Develi','Felahiye','Hacılar','İncesu','Kocasinan','Melikgazi','Özvatan','Pınarbaşı','Sarıoğlan','Sarız','Talas','Tomarza','Yahyalı','Yeşilhisar'],
    'Kırıkkale': ['Bahşılı','Balışeyh','Çelebi','Delice','Karakeçili','Keskin','Merkez','Sulakyurt','Yahşihan'],
    'Kırklareli': ['Babaeski','Demirköy','Kofçaz','Lüleburgaz','Merkez','Pehlivanköy','Pınarhisar','Vize'],
    'Kırşehir': ['Akçakent','Akpınar','Boztepe','Çiçekdağı','Kaman','Merkez','Mucur'],
    'Kilis': ['Elbeyli','Merkez','Musabeyli','Polateli'],
    'Kocaeli': ['Başiskele','Çayırova','Darıca','Derince','Dilovası','Gebze','Gölcük','İzmit','Kandıra','Karamürsel','Kartepe','Körfez'],
    'Konya': ['Ahırlı','Akören','Akşehir','Altınekin','Beyşehir','Bozkır','Cihanbeyli','Çeltik','Çumra','Derbent','Derebucak','Doğanhisar','Emirgazi','Ereğli','Güneysınır','Hadim','Halkapınar','Hüyük','Ilgın','Kadınhanı','Karapınar','Karatay','Kulu','Meram','Sarayönü','Selçuklu','Seydişehir','Taşkent','Tuzlukçu','Yalıhüyük','Yunak'],
    'Kütahya': ['Altıntaş','Aslanapa','Çavdarhisar','Domaniç','Dumlupınar','Emet','Gediz','Hisarcık','Merkez','Pazarlar','Şaphane','Simav','Tavşanlı'],
    'Malatya': ['Akçadağ','Arapgir','Arguvan','Battalgazi','Darende','Doğanşehir','Doğanyol','Hekimhan','Kale','Kuluncak','Pütürge','Yazıhan','Yeşilyurt'],
    'Manisa': ['Ahmetli','Akhisar','Alaşehir','Demirci','Gölmarmara','Gördes','Kırkağaç','Köprübaşı','Kula','Salihli','Sarıgöl','Saruhanlı','Selendi','Soma','Şehzadeler','Turgutlu','Yunusemre'],
    'Mardin': ['Artuklu','Dargeçit','Derik','Kızıltepe','Mazıdağı','Midyat','Nusaybin','Ömerli','Savur','Yeşilli'],
    'Mersin': ['Akdeniz','Anamur','Aydıncık','Bozyazı','Çamlıyayla','Erdemli','Gülnar','Mezitli','Mut','Silifke','Tarsus','Toroslar','Yenişehir'],
    'Muğla': ['Bodrum','Dalaman','Datça','Fethiye','Kavaklıdere','Köyceğiz','Marmaris','Menteşe','Milas','Ortaca','Seydikemer','Ula','Yatağan'],
    'Muş': ['Bulanık','Hasköy','Korkut','Malazgirt','Merkez','Varto'],
    'Nevşehir': ['Acıgöl','Avanos','Derinkuyu','Gülşehir','Hacıbektaş','Kozaklı','Merkez','Ürgüp'],
    'Niğde': ['Altunhisar','Bor','Çamardı','Çiftlik','Merkez','Ulukışla'],
    'Ordu': ['Akkuş','Altınordu','Aybastı','Çamaş','Çatalpınar','Çaybaşı','Fatsa','Gölköy','Gülyalı','Gürgentepe','İkizce','Kabadüz','Kabataş','Korgan','Kumru','Mesudiye','Perşembe','Ulubey','Ünye'],
    'Osmaniye': ['Bahçe','Düziçi','Hasanbeyli','Kadirli','Merkez','Sumbas','Toprakkale'],
    'Rize': ['Ardeşen','Çamlıhemşin','Çayeli','Derepazarı','Fındıklı','Güneysu','Hemşin','İkizdere','İyidere','Kalkandere','Merkez','Pazar'],
    'Sakarya': ['Adapazarı','Akyazı','Arifiye','Erenler','Ferizli','Geyve','Hendek','Karapürçek','Karasu','Kaynarca','Kocaali','Pamukova','Sapanca','Serdivan','Söğütlü','Taraklı'],
    'Samsun': ['Alaçam','Asarcık','Atakum','Ayvacık','Bafra','Canik','Çarşamba','Havza','İlkadım','Kavak','Ladik','Ondokuzmayıs','Salıpazarı','Tekkeköy','Terme','Vezirköprü','Yakakent'],
    'Siirt': ['Baykan','Eruh','Kurtalan','Merkez','Pervari','Şirvan','Tillo'],
    'Sinop': ['Ayancık','Boyabat','Dikmen','Durağan','Erfelek','Gerze','Merkez','Saraydüzü','Türkeli'],
    'Sivas': ['Akıncılar','Altınyayla','Divriği','Doğanşar','Gemerek','Gölova','Gürün','Hafik','İmranlı','Kangal','Koyulhisar','Merkez','Suşehri','Şarkışla','Ulaş','Yıldızeli','Zara'],
    'Şanlıurfa': ['Akçakale','Birecik','Bozova','Ceylanpınar','Eyyübiye','Haliliye','Harran','Hilvan','Karaköprü','Siverek','Suruç','Viranşehir'],
    'Şırnak': ['Beytüşşebap','Cizre','Güçlükonak','İdil','Merkez','Silopi','Uludere'],
    'Tekirdağ': ['Çerkezköy','Çorlu','Ergene','Hayrabolu','Kapaklı','Malkara','Marmaraereğlisi','Muratlı','Saray','Süleymanpaşa','Şarköy'],
    'Tokat': ['Almus','Artova','Başçiftlik','Erbaa','Merkez','Niksar','Pazar','Reşadiye','Sulusaray','Turhal','Yeşilyurt','Zile'],
    'Trabzon': ['Akçaabat','Araklı','Arsin','Beşikdüzü','Çarşıbaşı','Çaykara','Dernekpazarı','Düzköy','Hayrat','Köprübaşı','Maçka','Of','Ortahisar','Sürmene','Şalpazarı','Tonya','Vakfıkebir','Yomra'],
    'Tunceli': ['Çemişgezek','Hozat','Mazgirt','Merkez','Nazımiye','Ovacık','Pertek','Pülümür'],
    'Uşak': ['Banaz','Eşme','Karahallı','Merkez','Sivaslı','Ulubey'],
    'Van': ['Bahçesaray','Başkale','Çaldıran','Çatak','Edremit','Erciş','Gevaş','Gürpınar','İpekyolu','Muradiye','Özalp','Saray','Tuşba'],
    'Yalova': ['Altınova','Armutlu','Çınarcık','Çiftlikköy','Merkez','Termal'],
    'Yozgat': ['Akdağmadeni','Aydıncık','Boğazlıyan','Çandır','Çayıralan','Çekerek','Kadışehri','Merkez','Saraykent','Sarıkaya','Sorgun','Şefaatli','Yenifakılı','Yerköy'],
    'Zonguldak': ['Alaplı','Çaycuma','Devrek','Ereğli','Gökçebey','Kilimli','Kozlu','Merkez']
  };

  // ---- Bulgaristan: 28 il (oblast) → belediyeler (obshtina) ----
  var BG = {
    'Blagoevgrad': ['Bansko','Belitsa','Blagoevgrad','Garmen','Gotse Delchev','Hadzhidimovo','Kresna','Petrich','Razlog','Sandanski','Satovcha','Simitli','Strumyani','Yakoruda'],
    'Burgas': ['Aytos','Burgas','Kameno','Karnobat','Malko Tarnovo','Nesebar','Pomorie','Primorsko','Ruen','Sozopol','Sredets','Sungurlare','Tsarevo'],
    'Dobrich': ['Balchik','Dobrich','Dobrichka','General Toshevo','Kavarna','Krushari','Shabla','Tervel'],
    'Gabrovo': ['Dryanovo','Gabrovo','Sevlievo','Tryavna'],
    'Haskovo': ['Dimitrovgrad','Harmanli','Haskovo','Ivaylovgrad','Lyubimets','Madzharovo','Mineralni Bani','Simeonovgrad','Stambolovo','Svilengrad','Topolovgrad'],
    'Kardzhali': ['Ardino','Chernoochene','Dzhebel','Kardzhali','Kirkovo','Krumovgrad','Momchilgrad'],
    'Kyustendil': ['Boboshevo','Bobov Dol','Dupnitsa','Kocherinovo','Kyustendil','Nevestino','Rila','Sapareva Banya','Treklyano'],
    'Lovech': ['Apriltsi','Letnitsa','Lovech','Lukovit','Teteven','Troyan','Ugarchin','Yablanitsa'],
    'Montana': ['Berkovitsa','Boychinovtsi','Brusartsi','Chiprovtsi','Georgi Damyanovo','Lom','Medkovets','Montana','Valchedram','Varshets','Yakimovo'],
    'Pazardzhik': ['Batak','Belovo','Bratsigovo','Lesichovo','Panagyurishte','Pazardzhik','Peshtera','Rakitovo','Septemvri','Strelcha','Velingrad'],
    'Pernik': ['Breznik','Zemen','Kovachevtsi','Pernik','Radomir','Tran'],
    'Pleven': ['Belene','Cherven Bryag','Dolna Mitropolia','Dolni Dabnik','Gulyantsi','Iskar','Knezha','Levski','Nikopol','Pleven','Pordim'],
    'Plovdiv': ['Asenovgrad','Brezovo','Hisarya','Kaloyanovo','Karlovo','Krichim','Kuklen','Laki','Maritsa','Parvomay','Perushtitsa','Plovdiv','Rakovski','Rodopi','Sadovo','Sopot','Stamboliyski','Saedinenie'],
    'Razgrad': ['Isperih','Kubrat','Loznitsa','Razgrad','Samuil','Tsar Kaloyan','Zavet'],
    'Ruse': ['Borovo','Byala','Dve Mogili','Ivanovo','Ruse','Slivo Pole','Tsenovo','Vetovo'],
    'Shumen': ['Hitrino','Kaolinovo','Kaspichan','Nikola Kozlevo','Novi Pazar','Shumen','Smyadovo','Veliki Preslav','Venets','Varbitsa'],
    'Silistra': ['Alfatar','Dulovo','Glavinitsa','Kaynardzha','Silistra','Sitovo','Tutrakan'],
    'Sliven': ['Kotel','Nova Zagora','Sliven','Tvarditsa'],
    'Smolyan': ['Banite','Borino','Chepelare','Devin','Dospat','Madan','Nedelino','Rudozem','Smolyan','Zlatograd'],
    'Sofia (grad)': ['Sofia'],
    'Sofia (oblast)': ['Anton','Botevgrad','Bozhurishte','Chavdar','Chelopech','Dolna Banya','Dragoman','Elin Pelin','Etropole','Godech','Gorna Malina','Ihtiman','Koprivshtitsa','Kostenets','Kostinbrod','Mirkovo','Pirdop','Pravets','Samokov','Slivnitsa','Svoge','Zlatitsa'],
    'Stara Zagora': ['Bratya Daskalovi','Chirpan','Galabovo','Gurkovo','Kazanlak','Maglizh','Nikolaevo','Opan','Pavel Banya','Radnevo','Stara Zagora'],
    'Targovishte': ['Antonovo','Omurtag','Opaka','Popovo','Targovishte'],
    'Varna': ['Aksakovo','Avren','Beloslav','Byala','Dalgopol','Devnya','Dolni Chiflik','Provadia','Suvorovo','Valchi Dol','Varna','Vetrino'],
    'Veliko Tarnovo': ['Elena','Gorna Oryahovitsa','Lyaskovets','Pavlikeni','Polski Trambesh','Strazhitsa','Suhindol','Svishtov','Veliko Tarnovo','Zlataritsa'],
    'Vidin': ['Belogradchik','Boynitsa','Bregovo','Chuprene','Dimovo','Gramada','Kula','Makresh','Novo Selo','Ruzhintsi','Vidin'],
    'Vratsa': ['Borovan','Byala Slatina','Hayredin','Kozloduy','Krivodol','Mezdra','Mizia','Oryahovo','Roman','Vratsa'],
    'Yambol': ['Bolyarovo','Elhovo','Straldzha','Tundzha','Yambol']
  };

  // ---- Slovakya: 8 bölge (kraj) → 79 ilçe (okres) ----
  var SK = {
    'Bratislavský kraj': ['Bratislava I','Bratislava II','Bratislava III','Bratislava IV','Bratislava V','Malacky','Pezinok','Senec'],
    'Trnavský kraj': ['Dunajská Streda','Galanta','Hlohovec','Piešťany','Senica','Skalica','Trnava'],
    'Trenčiansky kraj': ['Bánovce nad Bebravou','Ilava','Myjava','Nové Mesto nad Váhom','Partizánske','Považská Bystrica','Prievidza','Púchov','Trenčín'],
    'Nitriansky kraj': ['Komárno','Levice','Nitra','Nové Zámky','Šaľa','Topoľčany','Zlaté Moravce'],
    'Žilinský kraj': ['Bytča','Čadca','Dolný Kubín','Kysucké Nové Mesto','Liptovský Mikuláš','Martin','Námestovo','Ružomberok','Turčianske Teplice','Tvrdošín','Žilina'],
    'Banskobystrický kraj': ['Banská Bystrica','Banská Štiavnica','Brezno','Detva','Krupina','Lučenec','Poltár','Revúca','Rimavská Sobota','Veľký Krtíš','Zvolen','Žarnovica','Žiar nad Hronom'],
    'Prešovský kraj': ['Bardejov','Humenné','Kežmarok','Levoča','Medzilaborce','Poprad','Prešov','Sabinov','Snina','Stará Ľubovňa','Stropkov','Svidník','Vranov nad Topľou'],
    'Košický kraj': ['Gelnica','Košice I','Košice II','Košice III','Košice IV','Košice-okolie','Michalovce','Rožňava','Sobrance','Spišská Nová Ves','Trebišov']
  };

  // ---- Romanya: 42 il (județ) → başlıca şehir/ilçeler ----
  var RO = {
    'Alba': ['Abrud','Aiud','Alba Iulia','Blaj','Câmpeni','Cugir','Ocna Mureș','Sebeș','Teiuș','Zlatna'],
    'Arad': ['Arad','Chișineu-Criș','Curtici','Ineu','Lipova','Nădlac','Pâncota','Pecica','Sântana','Sebiș'],
    'Argeș': ['Câmpulung','Costești','Curtea de Argeș','Mioveni','Pitești','Ștefănești','Topoloveni'],
    'Bacău': ['Bacău','Buhuși','Comănești','Dărmănești','Moinești','Onești','Slănic-Moldova','Târgu Ocna'],
    'Bihor': ['Aleșd','Beiuș','Marghita','Nucet','Oradea','Salonta','Ștei','Valea lui Mihai','Vașcău'],
    'Bistrița-Năsăud': ['Beclean','Bistrița','Năsăud','Sângeorz-Băi'],
    'Botoșani': ['Botoșani','Bucecea','Darabani','Dorohoi','Flămânzi','Săveni','Ștefănești'],
    'Brașov': ['Brașov','Codlea','Făgăraș','Ghimbav','Predeal','Râșnov','Rupea','Săcele','Victoria','Zărnești'],
    'Brăila': ['Brăila','Făurei','Ianca','Însurăței'],
    'București': ['Sector 1','Sector 2','Sector 3','Sector 4','Sector 5','Sector 6'],
    'Buzău': ['Buzău','Nehoiu','Pătârlagele','Pogoanele','Râmnicu Sărat'],
    'Caraș-Severin': ['Anina','Băile Herculane','Bocșa','Caransebeș','Moldova Nouă','Oravița','Oțelu Roșu','Reșița'],
    'Călărași': ['Budești','Călărași','Fundulea','Lehliu-Gară','Oltenița'],
    'Cluj': ['Câmpia Turzii','Cluj-Napoca','Dej','Gherla','Huedin','Turda'],
    'Constanța': ['Băneasa','Cernavodă','Constanța','Eforie','Hârșova','Mangalia','Medgidia','Murfatlar','Năvodari','Negru Vodă','Ovidiu','Techirghiol'],
    'Covasna': ['Baraolt','Covasna','Întorsura Buzăului','Sfântu Gheorghe','Târgu Secuiesc'],
    'Dâmbovița': ['Fieni','Găești','Moreni','Pucioasa','Răcari','Târgoviște','Titu'],
    'Dolj': ['Bailești','Băilești','Calafat','Craiova','Dăbuleni','Filiași','Segarcea'],
    'Galați': ['Berești','Galați','Târgu Bujor','Tecuci'],
    'Giurgiu': ['Bolintin-Vale','Giurgiu','Mihăilești'],
    'Gorj': ['Bumbești-Jiu','Motru','Novaci','Rovinari','Târgu Cărbunești','Târgu Jiu','Tismana','Țicleni'],
    'Harghita': ['Bălan','Borsec','Cristuru Secuiesc','Gheorgheni','Miercurea Ciuc','Odorheiu Secuiesc','Toplița','Vlăhița'],
    'Hunedoara': ['Brad','Călan','Deva','Hațeg','Hunedoara','Lupeni','Orăștie','Petroșani','Petrila','Simeria','Vulcan'],
    'Ialomița': ['Amara','Căzănești','Fetești','Fierbinți-Târg','Slobozia','Țăndărei','Urziceni'],
    'Iași': ['Hârlău','Iași','Pașcani','Podu Iloaiei','Târgu Frumos'],
    'Ilfov': ['Bragadiru','Buftea','Chitila','Măgurele','Otopeni','Pantelimon','Popești-Leordeni','Voluntari'],
    'Maramureș': ['Baia Mare','Baia Sprie','Borșa','Cavnic','Dragomirești','Săliștea de Sus','Seini','Sighetu Marmației','Șomcuta Mare','Târgu Lăpuș','Vișeu de Sus'],
    'Mehedinți': ['Baia de Aramă','Drobeta-Turnu Severin','Orșova','Strehaia','Vânju Mare'],
    'Mureș': ['Iernut','Luduș','Reghin','Sarmașu','Sighișoara','Sovata','Târgu Mureș','Târnăveni','Ungheni'],
    'Neamț': ['Bicaz','Piatra Neamț','Roman','Roznov','Târgu Neamț'],
    'Olt': ['Balș','Caracal','Corabia','Drăgănești-Olt','Piatra-Olt','Scornicești','Slatina'],
    'Prahova': ['Azuga','Băicoi','Boldești-Scăeni','Breaza','Bușteni','Câmpina','Comarnic','Mizil','Ploiești','Plopeni','Sinaia','Slănic','Urlați','Vălenii de Munte'],
    'Satu Mare': ['Ardud','Carei','Livada','Negrești-Oaș','Satu Mare','Tășnad'],
    'Sălaj': ['Cehu Silvaniei','Jibou','Șimleu Silvaniei','Zalău'],
    'Sibiu': ['Agnita','Avrig','Cisnădie','Copșa Mică','Dumbrăveni','Mediaș','Miercurea Sibiului','Ocna Sibiului','Săliște','Sibiu','Tălmaciu'],
    'Suceava': ['Broșteni','Cajvana','Câmpulung Moldovenesc','Dolhasca','Fălticeni','Frasin','Gura Humorului','Liteni','Milișăuți','Rădăuți','Salcea','Siret','Solca','Suceava','Vatra Dornei','Vicovu de Sus'],
    'Teleorman': ['Alexandria','Roșiorii de Vede','Turnu Măgurele','Videle','Zimnicea'],
    'Timiș': ['Buziaș','Ciacova','Deta','Făget','Gătaia','Jimbolia','Lugoj','Recaș','Sânnicolau Mare','Timișoara'],
    'Tulcea': ['Babadag','Isaccea','Măcin','Sulina','Tulcea'],
    'Vaslui': ['Bârlad','Huși','Murgeni','Negrești','Vaslui'],
    'Vâlcea': ['Băbeni','Băile Govora','Băile Olănești','Bălcești','Berbești','Brezoi','Călimănești','Drăgășani','Horezu','Ocnele Mari','Râmnicu Vâlcea'],
    'Vrancea': ['Adjud','Focșani','Mărășești','Odobești','Panciu']
  };

  var PROVINCES = { TR: TR, BG: BG, RO: RO, SK: SK };

  // ---- yardımcılar ----
  function el(tag, attrs) {
    var e = document.createElement(tag);
    if (attrs) for (var k in attrs) { if (k === 'text') e.textContent = attrs[k]; else e.setAttribute(k, attrs[k]); }
    return e;
  }
  function loadSaved() { try { return JSON.parse(localStorage.getItem(LS_KEY)) || {}; } catch (e) { return {}; } }
  function save(state) { try { localStorage.setItem(LS_KEY, JSON.stringify(state)); } catch (e) {} }

  function injectCSS() {
    if (document.getElementById('ca-style')) return;
    var css = ''
      + '.cart-address{margin:16px 0;padding:16px;border:1px solid #e5e5e5;border-radius:8px;background:#fafafa}'
      + '.cart-address__title{font-weight:600;margin-bottom:12px;font-size:15px}'
      + '.cart-address__field{margin-bottom:10px}'
      + '.cart-address__field[hidden]{display:none}'
      + '.cart-address__label{display:block;font-size:12px;color:#666;margin-bottom:4px}'
      + '.cart-address__select{width:100%;box-sizing:border-box;padding:10px 12px;border:1px solid #ccc;border-radius:6px;background:#fff;font-size:14px;color:#111}'
      + "select.cart-address__select{-webkit-appearance:none;appearance:none;background-image:url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='8' viewBox='0 0 12 8'%3E%3Cpath fill='%23666' d='M6 8L0 0h12z'/%3E%3C/svg%3E\");background-repeat:no-repeat;background-position:right 12px center;padding-right:32px}"
      + '.cart-address__select:disabled{background-color:#f0f0f0;color:#999;cursor:not-allowed}'
      + '.cart-address__error{color:#c0392b;font-size:13px;margin:8px 0 0}'
      + '.cart-address__error[hidden]{display:none}';
    var s = el('style', { id: 'ca-style' });
    s.textContent = css;
    (document.head || document.documentElement).appendChild(s);
  }

  function fillProvinces(sel, data) {
    sel.innerHTML = '';
    sel.appendChild(el('option', { value: '', text: 'İl seçin' }));
    Object.keys(data).forEach(function (il) { sel.appendChild(el('option', { value: il, text: il })); });
  }
  function fillDistricts(sel, data, il) {
    sel.innerHTML = '';
    sel.appendChild(el('option', { value: '', text: 'İlçe seçin' }));
    ((data && data[il]) || []).forEach(function (ilce) { sel.appendChild(el('option', { value: ilce, text: ilce })); });
  }

  var roots = [];

  function initRoot(root) {
    var form = root.closest('form');
    var country = root.querySelector('.ca-country');
    var province = root.querySelector('.ca-province');
    var district = root.querySelector('.ca-district');
    var cityText = root.querySelector('.ca-citytext');
    var distText = root.querySelector('.ca-districttext');
    var fProv = root.querySelector('.ca-f-province');
    var fDist = root.querySelector('.ca-f-district');
    var fCity = root.querySelector('.ca-f-citytext');
    var fDistT = root.querySelector('.ca-f-districttext');
    var errorEl = root.querySelector('.ca-error');

    // Ülke seçenekleri
    country.appendChild(el('option', { value: '', text: 'Ülke seçin' }));
    COUNTRIES.forEach(function (c) { country.appendChild(el('option', { value: c.code, text: c.name })); });

    // Ülkenin il/ilçe verisi var mı?
    function dataFor() { return PROVINCES[country.value] || null; }

    // resetSub=true ise il/ilçe seçimi sıfırlanır (ülke değişince)
    function applyCountryUI(resetSub) {
      var data = dataFor();
      var hasData = !!data;
      fProv.hidden = !hasData; fDist.hidden = !hasData;
      fCity.hidden = hasData;  fDistT.hidden = hasData;
      if (hasData) {
        fillProvinces(province, data);
        province.disabled = false;
        if (resetSub) { district.innerHTML = ''; district.disabled = true; }
        else { district.disabled = !province.value; }
      }
    }

    function hideErr() { if (errorEl) errorEl.hidden = true; }
    function showErr(msg) {
      if (!errorEl) return;
      errorEl.textContent = msg;
      errorEl.hidden = false;
      root.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }

    function persist() {
      save({ country: country.value, province: province.value, district: district.value, city: cityText.value, dist: distText.value });
      syncOthers(api);
    }

    function restore() {
      var s = loadSaved();
      country.value = (s.country != null && s.country !== '') ? s.country : 'TR';
      if (!country.value) country.value = 'TR';
      applyCountryUI(false);
      var data = dataFor();
      if (data) {
        if (s.province && data[s.province]) {
          province.value = s.province;
          fillDistricts(district, data, s.province);
          district.disabled = false;
          if (s.district && data[s.province].indexOf(s.district) !== -1) district.value = s.district;
        }
      } else {
        cityText.value = s.city || '';
        distText.value = s.dist || '';
      }
    }

    country.addEventListener('change', function () { applyCountryUI(true); hideErr(); persist(); });
    province.addEventListener('change', function () {
      var data = dataFor();
      if (province.value && data) { fillDistricts(district, data, province.value); district.disabled = false; }
      else { district.innerHTML = ''; district.disabled = true; }
      hideErr(); persist();
    });
    district.addEventListener('change', function () { hideErr(); persist(); });
    cityText.addEventListener('input', function () { hideErr(); persist(); });
    distText.addEventListener('input', function () { hideErr(); persist(); });

    var api = {
      root: root, country: country, province: province, district: district,
      cityText: cityText, distText: distText, showErr: showErr, hideErr: hideErr,
      dataFor: dataFor, restore: restore
    };
    roots.push(api);

    restore();

    // Checkout yönlendirmesi yalnızca native checkout butonu olan formda (sepet sayfası).
    var btn = form ? form.querySelector('[name="checkout"]') : null;
    if (btn) {
      btn.addEventListener('click', function (ev) {
        var data = dataFor();
        if (!country.value) { ev.preventDefault(); ev.stopImmediatePropagation(); showErr('Lütfen ülke seçin.'); return; }
        if (data) {
          if (!province.value || !district.value) { ev.preventDefault(); ev.stopImmediatePropagation(); showErr('Lütfen İl ve İlçe seçin.'); return; }
        } else {
          if (!cityText.value.trim()) { ev.preventDefault(); ev.stopImmediatePropagation(); showErr('Lütfen şehir/bölge yazın.'); return; }
        }
        ev.preventDefault(); ev.stopImmediatePropagation();
        goToCheckout(api, btn);
      }, true); // capture: tema doğrulamalarından önce
    }
  }

  function syncOthers(changed) {
    roots.forEach(function (a) { if (a !== changed) a.restore(); });
  }

  function goToCheckout(api, btn) {
    if (btn) btn.setAttribute('aria-busy', 'true');
    var data = api.dataFor();
    var city = data ? api.province.value : (api.cityText.value || '').trim();
    var dist = data ? api.district.value : (api.distText.value || '').trim();
    fetch('/cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (!cart.items || !cart.items.length) { window.location.href = '/checkout'; return; }
        var complex = cart.items.some(function (it) {
          return (it.properties && Object.keys(it.properties).length) || it.selling_plan_allocation;
        });
        if (complex) { window.location.href = '/checkout'; return; }
        var lines = cart.items.map(function (it) { return it.variant_id + ':' + it.quantity; }).join(',');
        var params = ['checkout[shipping_address][country]=' + encodeURIComponent(api.country.value)];
        if (city) params.push('checkout[shipping_address][city]=' + encodeURIComponent(city));
        if (dist) params.push('checkout[shipping_address][address2]=' + encodeURIComponent(dist));
        window.location.href = '/cart/' + lines + '?' + params.join('&');
      })
      .catch(function () { window.location.href = '/checkout'; });
  }

  function init() {
    var found = document.querySelectorAll('[data-cart-address]');
    if (!found.length) return;
    injectCSS();
    Array.prototype.forEach.call(found, function (root) {
      if (root.getAttribute('data-ca-init')) return;
      root.setAttribute('data-ca-init', '1');
      initRoot(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
